import Footer from "./Footer";

const DeleteAccount = () => {
  return (
    <>
      {/* Page Content */}
      <div
        className="d-flex flex-column justify-content-center align-items-center text-center"
        style={{ minHeight: "70vh" }}
      >
        <h3 className="fw-bold mb-3">Delete Your Account</h3>

        <p className="text-muted">
          If you want to delete your account, please mail with your registered
          email id at <strong> paresh@agmetech.com</strong>
        </p>
      </div>

      {/* Footer */}
      {/* <Footer /> */}
    </>
  );
};

export default DeleteAccount;
